import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    page: {
        flex: 1,
        minHeight: 0,
        overflow: "auto",
    },
    content: {
        maxWidth: 960,
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
    },
    licenseText: {
        margin: 0,
        padding: theme.spacing(3),
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.emteria.background.paper,
        color: theme.palette.emteria.text.primary,
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
        fontSize: theme.typography.body2.fontSize,
        lineHeight: 1.5,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        overflowX: "auto",
    },
    stateBox: {
        display: "flex",
        justifyContent: "center",
        padding: theme.spacing(8, 0),
    },
}));
